var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper pr"},[_c('serve-item',{on:{"service-type-id":_vm.selServiceType}}),_c('div',{staticClass:"wrap-form"},[_c('serve-list',{ref:"table",attrs:{"serviceTypeId":_vm.serviceTypeId}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }